import LocalizedStrings from 'localized-strings';

export default new LocalizedStrings({
  en: {
    cta: 'Ok, I understand',
    description:
      'We’re sorry about this and we’re doing everything we can to allow you to join us in the future.',
    title:
      'You are not eligible to open a pro Shine account following an analysis of your identity',
  },
  fr: {
    cta: 'Ok, c’est compris',
    description:
      'Nous en sommes désolés et mettons tout en œuvre pour vous permettre de nous rejoindre à l’avenir.',
    title:
      'Vous n’êtes pas éligible à l’ouverture d’un compte pro Shine suite à l’analyse de votre identité',
  },
} as const);
